import { isApiError } from '@nucleus-commerce/api-client/transport';

export type FileProblem =
  | { kind: 'missingColumns'; missing: string[] }
  | { kind: 'noRows' }
  | { kind: 'wrongType' }
  | { kind: 'tooLarge' };

/**
 * Upload refusals that belong on the file field rather than in a toast: 422 on `body` (with
 * `meta.missing` when required columns are absent, otherwise a file without data rows), 415 for
 * a non-CSV body, 413 when the file is over the size limit.
 */
export function importFileProblem(error: unknown): FileProblem | null {
  if (!isApiError(error)) return null;
  if (error.status === 415) return { kind: 'wrongType' };
  if (error.status === 413) return { kind: 'tooLarge' };
  if (error.status !== 422) return null;
  const missing = error.meta.missing;
  if (Array.isArray(missing) && missing.length > 0) {
    return { kind: 'missingColumns', missing: missing.map(String) };
  }
  return error.fieldErrors.body ? { kind: 'noRows' } : null;
}
